import KitActivationForPartners from './KitActivationForPartners';
import { InformationStep } from './steps/InformationStep';
import { SurveyStep } from './steps/SurveyStep';
import { FinalStep } from './steps/FinalStep';
import { PartnerKitStep } from './types';

// Define the step configuration here
const partnerKitSteps: readonly PartnerKitStep[] = [
  {
    id: 'informationStep',
    Component: InformationStep,
  },
  {
    id: 'surveyStep',
    Component: SurveyStep,
    exactPath: true,
  },
  {
    id: 'finalStep',
    Component: FinalStep,
  },
] as const;

const PartnerKitActivationContainer = () => {
  // Pass the steps configuration down as a prop
  return <KitActivationForPartners steps={partnerKitSteps} />;
};

export default PartnerKitActivationContainer;
